<template>
  <input-widget v-if="mounted"
      type="select2"
      :attribute="attribute"
      :label="label"
      :display-field="displayField"
      value-field="id"
      :options="select2Options"
      :hint="hint"
      :items="getItems"
      :model="model"
      :rules="rules"
      :disabled="disabled"
      @select2Select="onSelect"
      @select2Unselect="onUnselect"/>
</template>


<script>
  import InputWidget from "../components/input-widget/InputWidget";
  import DependedFieldsService from "../../modules/setup/depended-fields/DependedFieldsService";
  import BaseModel from "@/core/components/input-widget/BaseModel";

  export default {
    name: "DynamicMainFieldInputWidget",
    components: {InputWidget},
    data() {
      return {
        mounted: false
      }
    },
    props: {
      model: {
        type: BaseModel,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      label: {
        type: [String, Boolean],
        default: null
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      expand: {
        type: String,
        default: ''
      },
      field: {
        type: Object,
        default: null
      },
      rules: {
        type: Object,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      locale: {
        type: String,
        default: null,
      }
    },
    methods: {
      displayField(item) {
        if (item.data && item.data[this.locale] && item.data[this.locale][this.field.key]) {
          return item.data[this.locale][this.field.key];
        }
        return '';
      },
      onSelect(data) {
        this.field.addChoice(this.locale, data);
        this.$emit('select', {item: data, field: this.field, locale: this.locale});
      },
      onUnselect() {
        this.$emit('unselect');
      },
      updateItems() {
        const value = this.model[this.attribute];
        if (!value) {
          return;
        }
        const data = {
          data: {}
        };
        data.data[this.locale] = {};
        data.data[this.locale][this.field.key] = value;
        this.field.addChoice(this.locale, data);
      }
    },
    computed: {
      select2Options() {
        return {
          minimumInputLength: 1,
          ajax: {
            url: '/api/v1/depended-fields/',
            delay: 500,
            transport: async (params, success, failure) => {
              const query = {
                key: this.field.key,
                language: this.locale,
                search: params.data.term,
                limit: 20,
                page: params.data.page || 1
              };
              const response = await DependedFieldsService.getDependedFieldsData(query);
              response.success ? success(response.body) : failure();
            },
            processResults: (data) => {
              const results = data.results.map(obj => {
                return {
                  id: obj.data[this.locale][this.field.key],
                  text: obj.data[this.locale][this.field.key],
                  data: obj.data
                };
              });
              return {
                results: results,
                pagination: {
                  more: !!data.next
                }
              }
            }
          }
        };
      },
      getItems() {
        return this.field.getChoices(this.locale);
      }
    },
    mounted() {
      this.updateItems();
      this.mounted = true;
    }
  }
</script>

<style scoped>

</style>
